
import { mapState } from "vuex";
import { configState, configGetters, configMutations } from "~/store/helpers";
export default {
  name:'MangeTags',
  props: {
    modalKey: String,
  },
  data() {
    return {
      tags: [
        { key: 'diabetes', display_name: 'Diabetes' },
        { key: 'disabilities', display_name: 'Disabilities' },
        { key: 'last_active', display_name: 'Last Active' },
        { key: 'glucose', display_name: 'Glucose' },
        { key: 'pre_boarding', display_name: 'Pre-Boarding' },
      ],
      selectedTag: null,
      addedTags: []
    };
  },
  created() {},
  computed: {
    ...configGetters,
  },
  methods: {
    addTag(event) {
      let newTag = this.tags.find(e => e.display_name == event)
      this.tags = this.tags.filter(e => e.display_name != event)
      this.addedTags.push(newTag)
      this.selectedTag = null
      this.$emit('selectedTags', this.addedTags)
    },
    removeTag(event) {
      let removedTag = this.addedTags.find(e => e.key == event)
      this.tags.push(removedTag)
      this.addedTags = this.addedTags.filter(e => e.key != event)
    }
  },
  components: {},
};

